module.exports = __webpack_public_path__ + "static/media/des1.710e4bca.jpg";